// src/redux/classSlice.js

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  get_leave,
  add_leave,
  update_leave,
  delete_leave,
} from "../Service/ApiServices.js";
import { toast } from "react-toastify";

const initialState = {
  hostelleaves: [],
  school_id: "",
  totalPages: 0,
  pageSize: 10,
  count: 0,
  activePage: 1,
  loading: false,
  error: null,
  addLoading: false,
  IsEditing: false,
  formData: {
    purpose: "",
    from_date: "",
    to_date: "",
    from_time: "",
    to_time: "",
    type: "Hostel Leave",
    contact_leave: "",
    address: "",
    consent_relation: "",
    relation_number: "",
    hostel_return_date: "",
    hostel_return_time: "",
  },
};

// Async Thunks for API Calls
export const fetchhostelleave = createAsyncThunk(
  "hostelleave/fetchhostelleave",
  async (
    { page, page_size, school_id, type, token, signal },
    { rejectWithValue }
  ) => {
    try {
      const response = await get_leave(
        page,
        page_size,
        school_id,
        type,
        token,
        signal
      );
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const createhostelleave = createAsyncThunk(
  "hostelleave/createhostelleave",
  async ({ data, school_id, token, signal }, { rejectWithValue }) => {
    try {
      const response = await add_leave(data, school_id, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
export const updatehostelleave = createAsyncThunk(
  "hostelleave/updatehostelleave",
  async ({ data, token, signal }, { rejectWithValue }) => {
    try {
      const response = await update_leave(data, token, signal);
      if (response.status) {

         console.log("response.response",response.response);
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const deletehostelleave = createAsyncThunk(
  "hostelleave/deletehostelleave",
  async ({ ids, token, signal }, { rejectWithValue }) => {
    try {
      const response = await delete_leave({ ids }, token, signal);
      if (response.status) {
        return response.response;
      } else {
        return rejectWithValue(response.response.message);
      }
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);
// Class Slice
const hostelleaveSlice = createSlice({
  name: "hostelleaves",
  initialState,
  reducers: {
    setActivePage(state, action) {
      state.activePage = action.payload;
    },
    updateFormData(state, action) {
      const { name, value } = action.payload;
      state.formData[name] = value;
    },
    EditFormData(state, action) {
      // The action should contain all the fields that need to be updated
      const { id, purpose, from_date, to_date, from_time, to_time,contact_leave,address,consent_relation,relation_number,hostel_return_date,hostel_return_time, } =
        action.payload;
      state.formData = { id, purpose, from_date, to_date, from_time, to_time,contact_leave,address,consent_relation,relation_number,hostel_return_date,hostel_return_time, };
    },
    resetFormData(state) {
      state.formData = {
        purpose: "",
        from_date: "",
        to_date: "",
        from_time: "",
        to_time: "",
        type: "Hostel Leave",
        contact_leave: "",
        address: "",
        consent_relation: "",
        relation_number: "",
        hostel_return_date: "",
        hostel_return_time: "",
      };
    },
    setHostelLeave(state, action) {
      state.hostelleaves = action.payload;
    },
    setIsEditing(state, action) {
      state.IsEditing = action.payload;
    },
    setPageSize(state, action) {
      state.pageSize = action.payload;
    },
    setSchoolId(state, action) {
      state.school_id = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      // Fetch Classes
      .addCase(fetchhostelleave.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchhostelleave.fulfilled, (state, action) => {
        state.loading = false;
        state.hostelleaves = action.payload.results;
        state.count = action.payload.count;
        state.totalPages = Math.ceil(action.payload.count / state.pageSize);
      })
      .addCase(fetchhostelleave.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // Add Class
      .addCase(createhostelleave.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(createhostelleave.fulfilled, (state, action) => {
        state.addLoading = false;
        state.hostelleaves = action.payload.data;
        state.IsEditing = false;
        toast.success(action.payload.message || "Something went wrong!");
      })
      .addCase(createhostelleave.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action.payload;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.IsEditing = false;
      })
      // Update Class
      .addCase(updatehostelleave.pending, (state) => {
        state.addLoading = true;
      })
      .addCase(updatehostelleave.fulfilled, (state, action) => {
        state.addLoading = false;
        state.IsEditing = false;

        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(updatehostelleave.rejected, (state, action) => {
        state.addLoading = false;
        state.error = action.payload;
        state.IsEditing = false;

        toast.info(action?.payload?.message || "Something went wrong!");
      })
      // Delete Class
      .addCase(deletehostelleave.pending, (state) => {
        state.loading = true;
      })
      .addCase(deletehostelleave.fulfilled, (state, action) => {
        state.loading = false;
        toast.success(action?.payload?.message || "Something went wrong!");
      })
      .addCase(deletehostelleave.rejected, (state, action) => {
        state.loading = false;
        toast.info(action?.payload?.message || "Something went wrong!");
        state.error = action.payload;
      });
  },
});

// Export the actions and the reducer
export const {
  setHostelLeave,
  setActivePage,
  updateFormData,
  EditFormData,
  resetFormData,
  setIsEditing,
  setSchoolId,
  setPageSize,
} = hostelleaveSlice.actions;
export default hostelleaveSlice.reducer;
